import { httpClient } from '../httpClient';

export const usersApi = {
  getAll: (params) =>
    httpClient.get('/users/', { params }),

  getById: (id) =>
    httpClient.get(`/users/${id}`),

  create: (data) =>
    httpClient.post('/users/', data),

  update: (id, data) =>
    httpClient.put(`/users/${id}`, data),

  delete: (id) =>
    httpClient.delete(`/users/${id}`),

  restore: (id) =>
    httpClient.post(`/users/${id}/restore`),

  getRoles: () =>
    httpClient.get('/users/roles'),

  getRoleById: (id) =>
    httpClient.get(`/users/roles/${id}`),

  createRole: (data) =>
    httpClient.post('/users/roles', data),

  updateRole: (id, data) =>
    httpClient.put(`/users/roles/${id}`, data),

  deleteRole: (id) =>
    httpClient.delete(`/users/roles/${id}`),

  getPermissions: () =>
    httpClient.get('/users/permissions'),

  reset2FA: (userId) =>
    httpClient.delete('/auth/2fa', { data: { user_id: userId } }),
};
